<template>
    <div>
<!--        "<strong>{{ $_.get(activity, "payload.fullname") }} </strong>" visitor was unblocked by-->
<!--        <strong>{{ $_.get(activity, "actorUser.name") }}</strong>-->
        <span v-html="$t('notification.visitorUnblocked', { visitor: maskedPayloadFullname, agent:$_.get(activity, 'actorUser.name') })"></span>
    </div>
</template>
<script>
import Vue from "vue";
import activityVisitorMaskMixin from "./activityVisitorMaskMixin";

export default Vue.extend({
    name: "VisitorUnBlocked",
    mixins: [activityVisitorMaskMixin],
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        maskedPayloadFullname() {
            return this.maskVisitorDisplayName(this.$_.get(this.activity, "payload.fullname"));
        },
    },
});
</script>

<style scoped lang="scss"></style>
